import React from 'react'
import Svg from 'src/Components/shared/Svg'

const BotLogo = () => (
  <Svg viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath="url(#prefix__clip0_911_1822)">
        <circle cx={28.5} cy={28.5} r={27.5} fill="var(--brand-hb-homebot-fill)" />
        <path
          d="M55.8 28.5c0 15-12.2 27.2-27.2 27.2S1.2 43.5 1.2 28.5 13.5 1.2 28.5 1.2s27.3 12.3 27.3 27.3z"
          stroke="var(--brand-hb-homebot)"
          strokeWidth={2.5}
        />
        <path
          d="M40.6 23.9c-.9-.2-2.8-.4-4.4-.4-1.7 0-3.8.3-4.8.5-.2.8-.5 2.1-.5 3.7 0 1.5.2 2.8.4 3.5 1.1.2 3.4.5 4.8.5s3.5-.2 4.5-.4c.2-.7.4-2.1.5-3.5v-.6c-.1-1.3-.4-2.6-.5-3.3zm-5.2 6.4c-1.5 0-2.8-1.2-2.8-2.7 0-1.5 1.2-2.8 2.8-2.8 1.5 0 2.8 1.2 2.8 2.8 0 1.5-1.3 2.7-2.8 2.7z"
          fill="var(--brand-hb-white)"
        />
        <path
          d="M16.3 22.1c.8-.2 3-.5 5-.5s4.4.4 5.3.5c.6.1 1.1.6 1.3 1.2.2.7.4 1.7.5 3h.7c.1-1.3.4-2.4.5-3 .2-.6.7-1.1 1.3-1.2.9-.2 3.4-.5 5.3-.5s4 .3 4.9.5c-.1-1.3-1.2-2.2-2.5-2.2h-9.4v-1.5c1.9-.3 3.4-2 3.4-3.9 0-2.2-1.8-4-4-4s-4 1.8-4 4c0 1.9 1.4 3.6 3.2 3.9v1.5h-9.3c-1.4 0-2.5 1.1-2.5 2.4 0-.1.1-.2.3-.2zM42.9 27.8v.7c0 .8 0 1-.1 1.7s-.3 1.3-.3 1.7c-.2.6-.7 1.1-1.3 1.2-1 .1-3.4.4-5 .4s-4.3-.4-5.3-.6c-.6-.1-1.1-.6-1.3-1.2-.2-.6-.5-1.9-.5-3.6L29 28c-.1-.1-.3-.1-.4 0l-.1.1c-.1 1.6-.3 2.9-.5 3.6-.2.6-.7 1.1-1.3 1.2-1.1.2-3.7.6-5.3.6-1.6 0-4-.3-5-.4-.6-.1-1.2-.6-1.3-1.2-.1-.4-.2-1-.3-1.7-.1-.6-.1-1.1-.1-1.7v-.6-.2h-.2c-.8 0-1.4.6-1.4 1.4v5.5c0 .8.6 1.4 1.4 1.4H16v4.3c0 1.4 1.1 2.5 2.5 2.5h20.2c1.4 0 2.5-1.1 2.5-2.5V36h1.5c.8 0 1.4-.6 1.4-1.4v-5.5c-.2-.6-.6-1.1-1.2-1.3zm-4.8 9.9c0 .8-.7 1.6-1.6 1.6H20.7c-.9 0-1.6-.7-1.6-1.6v-.2c0-.8.7-1.6 1.6-1.6h15.8c.9 0 1.6.7 1.6 1.6v.2z"
          fill="var(--brand-hb-white)"
        />
        <path
          d="M16.8 23.9c-.2.7-.5 2.2-.5 3.6s.3 3 .5 3.7c1 .1 3.1.4 4.5.4s3.7-.3 4.8-.5c.2-.7.4-1.9.4-3.5s-.3-2.9-.5-3.7c-1-.2-3.1-.5-4.8-.5-1.6.1-3.5.4-4.4.5zm8.2 3.7c0 1.5-1.2 2.7-2.8 2.7-1.6 0-2.8-1.2-2.8-2.7 0-1.5 1.2-2.8 2.8-2.8 1.6 0 2.8 1.3 2.8 2.8z"
          fill="var(--brand-hb-white)"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_911_1822">
          <path fill="var(--brand-hb-white)" d="M0 0h57v57H0z" />
        </clipPath>
      </defs>
  </Svg>
)

export default BotLogo

